<div
  (click)="closeModal()"
  [class.active]="isOpenModal"
  class="modal-bg">
</div>

<div
  [class.active]="isOpenModal"
  [class.full]="isFull"
  [class.main-bg]="typeBg === 'main-bg'"
  class="modal">
  <button
    *ngIf="isCloseButtonHide || isFull"
    [class.full]="isFull"
    (click)="closeModal()"
    class="modal__close">
    <img
      src="assets/img/close-modal.svg"
      alt="Close"
      class="modal__close-icon">
  </button>

  <div class="modal__body">
    <ng-content></ng-content>
  </div>
</div>
